






























import { Prop, Component, Vue } from 'vue-property-decorator'
import { Project } from '@/api/model/project'
import { ProjectAPI } from '@/api/backend-client'

@Component
export default class ProjectsDetail extends Vue {
    @Prop({ required: true }) readonly projectId!: string
    project: Project = null
    loading: boolean = false

    async mounted() {
        this.loading = true
        await this.loadProject()
        this.loading = false
    }

    async loadProject(): Promise<void> {
        this.project = await ProjectAPI.get(this.projectId, true)
    }

    async goBackToLister(): Promise<void> {
        await this.$router.push({
            name: 'projects_list',
        })
    }
}
